var getTypeName = require('./getTypeName');

function getDefaultInterfaceName(props) {
  return '{' + Object.keys(props).map(function (prop) {
    return prop + ': ' + getTypeName(props[prop]);
  }).join(', ') + '}';
}

module.exports = getDefaultInterfaceName;



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/getDefaultInterfaceName.js
// module id = 202
// module chunks = 0